module.exports = __webpack_public_path__ + "img/exe.9ad6a8fa.png";